import { format } from 'date-fns'

export const formatDate = (time: number): string => {
  const dateTime = new Date(time * 1000)
  return (
    new Date(dateTime).getFullYear() +
    '/' +
    (new Date(dateTime).getMonth() + 1) +
    '/' +
    new Date(dateTime).getDate()
  )
}
/**
 * formatDataStringParam
 * @param strDate {string}
 * @param formatType {string}
 */
export const formatDataStringParam = (strDate: string | undefined, formatType = 'yyyy/MM/dd') => {
  if (!strDate || strDate === '' || strDate === '-') return '-'
  return format(new Date(strDate), formatType)
}
